import { PluginContainerData_Alignment } from 'ricos-schema';

const DEFAULTS = {
  config: {
    alignment: "center",
    size: "content",
    link: {
      target: "_blank",
      rel: ""
    }
  }
};
const EMBED_DEFAULTS = {
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true,
    width: {
      size: void 0,
      custom: "350"
    }
  }
};

export { DEFAULTS, EMBED_DEFAULTS };
//# sourceMappingURL=defaults.js.map
